import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTaskPageNavigation = (projectId, taskId) => {
  return useQuery({
    queryKey: ["task-page-navigation", projectId, taskId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/navigation`,
        signal,
      });
    },
  });
};
